import OrdiniListPage from "./pages/OrdiniListPage.vue";

export default {
OrdiniListPage,
};
